import { useQuery } from 'react-query';
import { userStudent } from 'src/models/user';
import { fetchUser } from 'src/services/instructors';

export default function useStudent(id) {
  return useQuery<userStudent>(['student', id], () => fetchUser(id), {
    enabled: id !== undefined && id !== 0
  });
}
